/* eslint-disable */
import React, { useState, useEffect, useRef } from 'react';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import { ReactComponent as CloseIcon } from '../../assets/images/close.svg';
import { ReactComponent as LoadingIcon } from '../../assets/images/loading-white.svg';
import exclamation from '../../assets/images/exclamation.png';
import image1 from '../../assets/images/goodPhoto1.jpg';
import image2 from '../../assets/images/goodPhoto2.png';
import image3 from '../../assets/images/goodPhoto3.png';
import image4 from '../../assets/images/badPhoto1.jpg';
import image5 from '../../assets/images/badPhoto2.jpg';
import image6 from '../../assets/images/badPhoto3.jpg';
import { useStore } from 'src/onboarding/store/store';
import { useMutation } from '@tanstack/react-query';
import { FileService } from 'src/onboarding/services/file.service';
import { AiService } from 'src/onboarding/services/ai.service';
import Analytics from '@web-solutions/module-analytics';
import { useRemoteConfig } from '@web-solutions/base-app/hooks/use-remote-config';
import { getLocalizedText } from 'core/utils/localized';
import './style.scss';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { Text } from 'src/onboarding/components/typography/Text/Text';
import { convertToCentimeters } from 'src/onboarding/helpers/convertToCm';
import { t } from '@web-solutions/module-localization';
import { getEnvUrl } from 'src/onboarding/helpers/getEnvUrl';
import Button from 'src/onboarding/components/ui/button/Button';
import { ImageUploadResponse, NewBodyResponse, ProcessImageData } from 'src/onboarding/types/api';
import ScanOverlay from 'src/onboarding/components/ScanOverlay';
import getLocale from 'src/localization/get-locale';

const FILE_PROCESSING_TIMEOUT = 5000;
const SCAN_DURATION = 4000;

function Page() {
  const { onNext, onPrev, currentIndex } = useNav();
  const locale = getLocale();

  const {
    height,
    idealWeight,
    gender,
    setShowPhotoProcessing,
    setPhotoProcessingUuid,
    setPhotoError,
    setGeneratedPhotoUrl,
    setExistTimeoutId,
    imageUrl,
    setImageUrl,
  } = useStore();

  const [image, setImage] = useState('');
  const [imageBase64, setImageBase64] = useState('');

  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showFaceScan, setShowFaceScan] = useState(false);
  const [hideScanLine, setHideScanLine] = useState(false);
  const [isBlurred, setIsBlurred] = useState(false);
  const { isShowedSkipButton, showFaceScan: faceScanEnabled, ltsPhotoExample } = useRemoteConfig();
  const [showErrorPopUp, setShowErrorPopUp] = useState(false);
  const { s3BaseUrl } = getEnvUrl();

  const [hasError, setHasError] = useState(false);
  const [isImageLoaded, setIsImageLoaded] = useState(false);
  const [filesError, setFilesError] = useState(false);

  useEffect(() => {
    if (image !== '') {
      processImageQuery.mutate(image);
    }
    setGeneratedPhotoUrl(null);
    setPhotoProcessingUuid('');
    setHasError(true);
  }, [image]);

  useEffect(() => {
    if (faceScanEnabled && showFaceScan && isImageLoaded && !isLoading) {
      Analytics.trackEvent('face-scan', 'show');
      const timer = setTimeout(() => {
        if (hasError) {
          setShowErrorPopUp(true);
          Analytics.trackEvent('face-scan-error', 'show');
        }
        setHideScanLine(true);
        // setIsBlurred(true);
        setShowPhotoProcessing(true);

        onNext()

      }, SCAN_DURATION);

      return () => clearTimeout(timer);
    }
  }, [showFaceScan, hasError, isImageLoaded, faceScanEnabled]);

  useEffect(() => {
    document.body.style.overflow = showFaceScan || filesError ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [showFaceScan, filesError]);

  useEffect(() => {
    if (isBlurred && hideScanLine && showFaceScan && !showErrorPopUp) {
      const redirectTimer = setTimeout(() => {
        onNext();
      }, SCAN_DURATION);

      return () => clearTimeout(redirectTimer);
    }
  }, [isBlurred, hideScanLine, showFaceScan, showErrorPopUp]);

  const handleChangeImage = (element) => {
    setIsImageLoaded(false);
    let file = element.files[0];
    const reader = new FileReader();
    reader.onloadend = function () {
      // setShowErrorPopUp(false);
      // setShowFaceScan(false);
      setHideScanLine(false);
      setIsBlurred(false);
      setImage('');

      setIsLoading(true);
      setTimeout(() => {
        setImage(file);
        setImageBase64(reader.result as string);

        // setShowPhotoProcessing(true);
        Analytics.trackEvent('user_loads', 'photo');
      }, 0);
    };
    reader.readAsDataURL(file);

    element.value = null;
  };

  const processImageQuery = useMutation({
    mutationFn: (file: string) => {
      return new Promise((resolve, reject) => {
        const timeoutId = setTimeout(() => {
          Analytics.trackEvent('files-timer', 'end');
          reject(new Error('timeout'));
        }, FILE_PROCESSING_TIMEOUT);

        FileService.createImage(file)
          .then((res) => {
            clearTimeout(timeoutId);
            resolve(res);
          })
          .catch((err) => {
            clearTimeout(timeoutId);
            reject(err);
          });
      });

    },
    onSuccess: (result: ImageUploadResponse) => {
      if (result.data && result.data.url) {
        setShowFaceScan(true);
        const uuid = result.data.url.split('/').pop().split('.').slice(0, -1).join('.');
        setImageUrl(result.data.url);
        setPhotoProcessingUuid(uuid);
        processImageNewBody.mutate({
          uuid,
          image: result.data.url,
          gender: gender,
          weight:
            idealWeight.type === 'lbs'
              ? Math.round(+idealWeight.value * 0.453592)
              : +idealWeight.value,
          height: height.type === 'cm' ? Number(height.cm) : convertToCentimeters(height.ft),
        });
        Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
          page: 'lts-photo-example',
          answer: 'continue',
        });
        if (!faceScanEnabled) {
          onNext();
        }
        setIsLoading(false);

        // setExistTimeoutId(
        //   setTimeout(() => {
        //     existImageQuery.mutate(uuid + '_output.png');
        //     setTimeout(() => {
        //       existImageQuery.mutate(uuid + '_output.png');
        //     }, 30000);
        //   }, 30000)
        // );
        setHasError(false);
      }
    },
    onError: (error) => {
      setPhotoError(true);
      setGeneratedPhotoUrl(null);
      setHasError(true);
      setIsLoading(false);
      setFilesError(true);
      console.log(error);

      Analytics.trackEvent('files-upload', 'error');
    },
  });

  const existImageQuery = useMutation({
    // mutationFn: (fileName: string) => {
    //   return FileService.isExist(fileName);
    // },
    // onSuccess: (result, variables) => {
    //   if (result.data && result.data.result) {
    //     const newUrl = `${s3BaseUrl}${variables}`;

    //     setGeneratedPhotoUrl(newUrl);
    //     setShowErrorPopUp(false);
    //     console.log(result.data.result);
    //     return;
    //   }
    //   setGeneratedPhotoUrl(null);
    // },
    // onError: (error) => {
    //   setPhotoError(true);
    //   setGeneratedPhotoUrl(null);
    // },
  });

  const processImageNewBody = useMutation({
    mutationFn: async (data: ProcessImageData): Promise<NewBodyResponse> => {
      const response = await AiService.newBody(data);
      return response.data;
    },
    onSuccess: (result: NewBodyResponse) => {
      Analytics.trackEvent('photo_upload', 'success');

      setPhotoError(false);
      setShowErrorPopUp(false);
      setIsLoading(false);
    },
    onError: (error) => {
      setPhotoError(true);
      setHasError(true);
      console.log(error);
    },
  });

  return (
    <div className={'layout ltsv-photo-example_new'}>
      <div className={'back'}>
        {currentIndex !== 0 && (
          <button onClick={onPrev}>
            <BackIcon />
          </button>
        )}
        {isShowedSkipButton && (
          <div
            className={'skip'}
            onClick={() => {
              Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
                page: 'lts-photo-example',
                answer: 'skip',
              });
              onNext();
            }}
          >
            {t('onboarding.lts-photo-example.skip')}
          </div>
        )}
      </div>
      <Title tag='h2' className='title'>
        {getLocalizedText(ltsPhotoExample.title, locale)}
      </Title>

      <div className={'content'}>
        <div className='content-wrapper'>
          <div>
            <Text bold size='m' className='s-title'>
              {t('onboarding.lts-photo-example.subTitle1')}
            </Text>

            <Text size='m' medium className='desc'>
              {t('onboarding.lts-photo-example.description1')}
            </Text>
          </div>

          <div className='items'>
            <img src={image1} alt='' />
            <img src={image2} alt='' />
            <img src={image3} alt='' />
          </div>
        </div>

        <div className='content-wrapper'>
          <div>
            <Text bold size='m' className='s-title'>
              {t('onboarding.lts-photo-example.subTitle2')}
            </Text>

            <Text size='m' medium className='desc'>
              {t('onboarding.lts-photo-example.description2')}
            </Text>
          </div>

          <div className='items'>
            <img src={image4} alt='' />
            <img src={image5} alt='' />
            <img src={image6} alt='' />
          </div>
        </div>
        <div className='overlay_new'></div>
      </div>

      <div className='controls'>
        <input
          type='file'
          id={'upload'}
          onClick={() => Analytics.trackEvent('pick_photo_continue', 'click')}
          onChange={(e) => {
            handleChangeImage(e.target);
          }}
          hidden
        />
        <label htmlFor='upload'>
          {isLoading && (
            <span style={{ marginRight: 5 }}>
              <LoadingIcon width={20} height={20} />
            </span>
          )}
          {t('onboarding.lts-photo-example.continue')}
        </label>
      </div>

      {isOpen && (
        <div className={'wrapper-picker'}>
          <div className={'picker'}>
            <div onClick={() => setIsOpen(false)} className={'close'}>
              <CloseIcon />
            </div>
            <div className='title'>Take a photo</div>
            {/*<button>Take a photo</button>*/}

            <input type='file' id={'upload'} onChange={(e) => handleChangeImage(e.target)} hidden />
            <label htmlFor='upload'>Upload photo</label>
          </div>
        </div>
      )}

      {showFaceScan && faceScanEnabled && !isLoading && (
        <ScanOverlay
          imageUrl={imageBase64}
          isBlurred={isBlurred}
          hideScanLine={hideScanLine}
          isImageLoaded={isImageLoaded}
          showErrorPopUp={showErrorPopUp}
          errorTitle={t('onboarding.lts-photo-example.faceScan.errorTitle')}
          errorDescription={t('onboarding.lts-photo-example.faceScan.errorSubTitle')}
          onImageLoad={() => setIsImageLoaded(true)}
          onChoosePhoto={() => {
            setShowFaceScan(false);
            // setShowPhotoProcessing(false);
            setPhotoError(false);
            setShowErrorPopUp(false);
            Analytics.trackEvent('face-scan-choose-photo', 'click');
          }}
          onSkip={() => {
            // setShowPhotoProcessing(false);
            onNext();
            Analytics.trackEvent('face-scan-skip', 'click');
          }}
        />
      )}

      {/* {filesError && (
        <>
          <div className='error-popup'>
            <div className='popup-title'>
              <img className='exclamation' src={exclamation} />

              <Text semibold>{t('onboarding.lts-photo-example.filesError')}</Text>
            </div>
            <Text regular size='m' className='error-text'>
              {t('onboarding.lts-photo-example.faceScan.errorSubTitle')}
            </Text>
            <div className='popup-controls'>
              <Button
                title={t('onboarding.lts-photo-example.faceScan.choosePhoto')}
                onClick={() => {
                  setShowPhotoProcessing(false);
                  setPhotoError(false);
                  setFilesError(false);
                  Analytics.trackEvent('files-error-choose-photo', 'click');
                }}
              />
            </div>
          </div>
        </>
      )} */}
    </div>
  );
}
export default Page;
